import * as ToggleGroup from '@radix-ui/react-toggle-group';
import { SunIcon, MoonIcon, MonitorIcon } from '@phosphor-icons/react';
import { useTheme, type Theme } from '@/contexts/theme-context';
import { toggleActiveClasses } from '@/ui/SegmentedControl';

const THEME_META = {
  light: { icon: SunIcon, label: 'Light' },
  dark: { icon: MoonIcon, label: 'Dark' },
  system: { icon: MonitorIcon, label: 'Auto' },
} as const;

const THEME_ORDER: Theme[] = ['light', 'system', 'dark'];

/** Light / Auto / Dark segmented switch in the sidebar footer. */
export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <ToggleGroup.Root
      type="single"
      value={theme}
      onValueChange={(v) => {
        if (v) setTheme(v as Theme);
      }}
      aria-label="Theme"
      className="mx-auto inline-flex items-center gap-0.5 rounded-full bg-black/6 dark:bg-white/5 p-0.5 ring-1 ring-inset ring-black/5 dark:ring-white/10"
    >
      {THEME_ORDER.map((t) => {
        const { icon: Icon, label } = THEME_META[t];
        return (
          <ToggleGroup.Item
            key={t}
            value={t}
            aria-label={label}
            title={label}
            className={`flex size-6 items-center justify-center rounded-full text-fg-muted outline-none transition-colors cursor-pointer hover:text-fg-secondary focus-visible:ring-2 focus-visible:ring-ring ${toggleActiveClasses}`}
          >
            <Icon size={14} weight={t === theme ? 'fill' : 'regular'} />
          </ToggleGroup.Item>
        );
      })}
    </ToggleGroup.Root>
  );
}
